import { render } from "./UserUpdate.vue?vue&type=template&id=21ab91cd&scoped=true"
import script from "./UserUpdate.vue?vue&type=script&lang=js"
export * from "./UserUpdate.vue?vue&type=script&lang=js"

import "./UserUpdate.vue?vue&type=style&index=0&id=21ab91cd&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-21ab91cd"]])

export default __exports__